import { Box3 } from 'three';

/**
 * Returns true if the object is a Box3.
 */
export const isBox3 = (object: any): object is Box3 => object && object.isBox3 === true;
